import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../../models/Constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service'; 

@Component({
  selector: 'app-view-note-log',
  templateUrl: './view-note-log.component.html',
  styleUrls: ['./view-note-log.component.scss']
})
export class ViewNoteLogComponent  {
  notelogContent: string = '';
  notelogError: string = '';
  noteLogLoader: boolean = false;
  loaderTimeoutId: any;
  showLoaderMsg: boolean = false;
  notelogErrorType: string = 'none';
  noteLogForm: FormGroup;
  saveSuccessMsg = '';
  saveErrorMsg = '';
 
  

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ViewNoteLogComponent>,
    public rootScope: RootScopeService,
    private apiService: ApiService,
    private fb: FormBuilder,
    private custBusService: CustBusService
  ) {
    this.noteLogForm = this.fb.group({
      newEntry: ['', Validators.required]
    });
    this.openNoteLogDialog();
  }



  // CCR1-11727 View Note Log for Imaging
  openNoteLogDialog() {
    this.noteLogLoader = true;
    this.startTimerForLoader();
    this.notelogContent = '';
    this.notelogErrorType = 'none';
    // this.saveSuccessMsg = '';
    // this.saveErrorMsg = '';

    this.apiService.getImagingNoteLogByDocumentId(this.data?.docId, this.rootScope?.activeCustTab?.id, this.rootScope?.activeCustTab?.clientId).subscribe({
      next: (res: any) => {
        this.noteLogLoader = false;
        //this.showLoaderMsg = false;
        clearTimeout(this.loaderTimeoutId);

        const comments = res?.data?.comments;
        if (!comments || comments.trim() === '') {
          this.notelogError = Constants.DATA_NOT_AVAIL_UI;
          this.notelogErrorType = 'noData';
          this.notelogContent = '';
        } else {


          let formatted = comments?.replace(/\r\n/g, '\n');
          // As per the demo feedback, removing the asterisks line that comes immediately after RESTFNID or @number. 
          // This keeps the separator at the start of each entry, but removes it after the ID line for cleaner formatting.
          formatted = formatted?.replace(/(RESTFNID|@\d+)\n\*{10,}\n/g, '$1\n\n');
          // Insert a blank line before each new entry (except the very first one).
          // This makes sure there is a visible separation between entries for readability.
          formatted = formatted?.replace(/(\n\*{10,}\n)/g, '\n$1');
          // Remove any extra blank line at the very start, if present, to avoid leading whitespace.
          formatted = formatted?.replace(/^\n+/, '');
          // As per the Sprint 4 demo feedback, Remove lines containing RESTFNID
          formatted = formatted?.split('\n').filter(line => !/^\s*RESTFNID\s*$/i.test(line)).join('\n');
          // Assign the final formatted string to notelogContent for display in the UI.
          this.notelogContent = formatted;
        }
        //this.noteLogForm.get('prevEntries')?.setValue(this.notelogContent);
      },
      error: () => {
        this.noteLogLoader = false;
        this.notelogError = Constants.EXTERNAL_API_FAILURE_MSG;
        this.notelogErrorType = 'apiError';
        clearTimeout(this.loaderTimeoutId);
    }
    });
  }

  // CCR1-11945 Add ability to save note log entry in Imaging
  onSaveNoteLog() {
  if (this.noteLogForm.invalid) return;
  this.noteLogLoader = true;
  this.saveSuccessMsg = '';
  this.saveErrorMsg = '';
  const comments = this.noteLogForm.get('newEntry')?.value;
  const authorEmail= this.rootScope?.emailId ? this.rootScope?.emailId : sessionStorage.getItem('emailId');
  const commentsString = `Author: ${authorEmail}\n\n${comments}`;
  const reqBody = { comments: commentsString };

  
  this.apiService.saveNotelogbyDocumentId(this.data?.docId,this.rootScope?.activeCustTab?.id,this.rootScope?.activeCustTab?.clientId,reqBody).subscribe({
    next: () => {
      this.noteLogLoader = false;
      this.saveSuccessMsg = Constants.NOTELOG_SAVE_SUCCESS_MSG;
      this.noteLogForm.get('newEntry')?.reset();
      this.openNoteLogDialog(); // Refresh immediately
  
    },
    error: () => {
      this.noteLogLoader = false;
      this.saveErrorMsg = Constants.SAVING_DATA_API_FAILURE_MSG;
    }
  });
}

  modalClose(): void {
    this.dialogRef.close();
  }

  startTimerForLoader() {
    let that = this;
    /*istanbul ignore next */
    this.loaderTimeoutId = setTimeout(() => { 
    }, 1 * this.rootScope.showLoaderMsgThreshold * 1000);
  }


}
